export const STORAGE_KEYS = {
  AUTH_EVENT: 'facilitykpi:auth:event',
  PERSIST_ROOT: 'persist:root',
  PERSIST_AUTH: 'persist:auth',
  LEGACY_PORTFOLIO_SELECTED_FACILITIES: 'portfolio-selected-facilities',
  portfolioSelectedFacilities: (userId) => `portfolio-selected-facilities:${userId || 'anonymous'}`,
};

export const LEGACY_AUTH_STORAGE_KEYS = [
  'access',
  'refresh',
  'accessTokenExpiration',
  'refreshTokenExpiration',
  'user',
  'image',
  'company',
  'user_facilities',
  'is_companyadmin',
  'is_superuser',
  'auth_role',
  'id_token',
];
